import { GeofenceTypeDto, PassengerSectorCountDto, RowReportTripTicket, SectorOriginFaresDto } from "@/dtos";
import { Sector, TripTicket } from "@/entities";
import { formatToCurrency, parseToLocalDateTimeFromUtc } from "@/helpers/utilities";
import { MapCoordinate } from "@/ui/components/maps/common/interfaces/map-coordinate";

export const formatRowReportSectorFareDto = (
    tripTickets: TripTicket[],
    sectorFares: SectorOriginFaresDto[],
    passengerSectorCount: PassengerSectorCountDto[],
    sectors: Sector[]
): RowReportTripTicket[] => {
    const result: RowReportTripTicket[] = [];
    let completedValue = 0;
    let mediaValue = 0;

    for (const tripTicket of tripTickets) {
        const isCompleted = !tripTicket.subfare.fare_type.is_exonerated && !tripTicket.subfare.fare_type.has_discount;
        const completed = isCompleted ? tripTicket.amont : 0;

        const isMedia = tripTicket.subfare.fare_type.has_discount;
        const media = isMedia ? tripTicket.amont : 0;
        const exonerated = tripTicket.subfare.fare_type.is_exonerated ? tripTicket.amont : 0;

        const sectorFareDto = sectorFares.find(x => x.sector_origin_id == tripTicket.sector_id_origin);
        if (sectorFareDto) {
            for (const sectoFareDto of sectorFareDto.sector_fares) {
                const completedSubfare = sectoFareDto.fare.subfares.find(x => !x.fare_type.has_discount && !x.fare_type.is_exonerated);
                completedValue = completedSubfare?.value ?? 0;

                const mediaSubfare = sectoFareDto.fare.subfares.find(x => x.fare_type.has_discount);
                mediaValue = mediaSubfare?.value ?? 0;
            }
        }

        const sector = sectors.find(x => x.id == tripTicket.sector_id_origin);
        const row = result.find(x => x.sector == (sector?.name ?? ''));
        const passengerCount = passengerSectorCount.find(x => x.sector_origin_id == tripTicket.sector_id_origin);
        const coordinate: MapCoordinate = {
            name: parseToLocalDateTimeFromUtc(`${tripTicket.date} ${tripTicket.hour}`),
            coordinate: [tripTicket.coordinates.longitude, tripTicket.coordinates.latitude],
            color: '#0635C9'
        }

        if (!row) {
            const row: RowReportTripTicket = {
                sector: (sector?.name ?? ''),
                sector_geofence: sector?.geofence ?? {} as GeofenceTypeDto,
                fare_type_completed: completed,
                fare_type_media: media,
                fare_type_exonerated: exonerated,
                ticket_sold: tripTicket.amont,
                counter: passengerCount ? passengerCount.total : 0,
                diference: 0,
                fare_type_completed_value: isCompleted ? tripTicket.value : 0,
                fare_type_media_value: isMedia ? tripTicket.value : 0,
                fare_total: tripTicket.value,
                trip_ticket_coords: [coordinate],
                counter_coords: passengerCount ? passengerCount.passenger_sector_count_coords : []
            }

            result.push(row);
            continue;
        }

        row.fare_type_completed += completed;
        row.fare_type_media += media;
        row.fare_type_exonerated += exonerated;
        row.ticket_sold += tripTicket.amont;
        row.fare_type_completed_value += isCompleted ? tripTicket.value : 0;
        row.fare_type_media_value += isMedia ? tripTicket.value : 0;
        row.fare_total += tripTicket.value;
        row.trip_ticket_coords.push(coordinate);
    }

    return result.map(x => {
        return {
            ...x,
            diference: x.ticket_sold - x.counter,
            fare_type_completed_value: `$ ${formatToCurrency(x.fare_type_completed_value)}` as any,
            fare_type_media_value: `$ ${formatToCurrency(x.fare_type_media_value)}` as any,
            fare_total: `$ ${formatToCurrency(x.fare_total)}` as any
        }
    });
}